const React = require("react");
const PropTypes = require("prop-types");
const { withRouter } = require("react-router-dom");
const { PRODUCTION_ENVIRONMENT } = require("constants/index");
const { recordLinkCommonV2 } = require("commonsUtilities/tagging");
const currencyHelper = require('utilities/currencyHelper');
const { FormattedText, formatText } = require("core/i18n").i18n;
const {
    formatAmount,
    formatAmountObject,
    getPlainAmountObject,
    formatCurrency,
    formatWithoutRound,
} = require("utilities/currencyHelper");
const {
    OneLineSymbolAmount,
} = require("commonsComponents/oneLineSymbolAmount");

const { OKButton } = require('commonsComponents/OKButton');
const PercentageBar = require('components/commons/PercentageBar/PercentageBar');


function buildProfitability(earnings, earningsPercentage) {
    const profitability = earnings && formatWithoutRound(earnings.amount, 2);
    const profitabilityCurrency = formatCurrency(earnings.currency);
    const percentage = formatWithoutRound(earningsPercentage, 2);
    return (
        <span>
            <span className="amount--bold">{profitability}</span>
            <span className="broker-products-wrap__earnings-currency">{profitabilityCurrency}</span>
            <span> | </span>
            <span className="percent--bold">{percentage}%</span>
        </span>
    )
}


const UserInvestedBox = ({ fund, investment, onlyOneFundWithSameIsin, history, location, isAlternativeFund, immFeatureFlags, brokerMyInvestments }) => {
    const query = new URLSearchParams(location.search);
    const contractId = query.get('contractId')
    const isNotProduction = __ENVIRONMENT__ !== PRODUCTION_ENVIRONMENT;
    const buyButtonFund = () => {
        if (isAlternativeFund) {
            recordLinkCommonV2({
                categoriaEvento: `ficha fondo alternativo/${fund.name}`,
                accionEvento: "clickButton", 
                etiquetaEvento: "comprar",
            }, isNotProduction);
        } else {
            recordLinkCommonV2({
                categoriaEvento: 'broker/fund',
                accionEvento: 'funds card',
                etiquetaEvento: 'comprar',
            }, isNotProduction);
        }


        if (isAlternativeFund) {
            return contractId ? history.push(`/myprofile/broker/buyAlternativeInvestmentFunds/${fund.isin}/${contractId}`)
                    : history.push(`/myprofile/broker/buyAlternativeInvestmentFunds/${fund.isin}/${fund.id}`)
        } else {
            return contractId ? history.push(`/myprofile/broker/buyInvestmentFunds/${fund.customInstitutionSecurityId}/${contractId}`)
                    : history.push(`/myprofile/broker/buyInvestmentFunds/${fund.customInstitutionSecurityId}/${fund.id}`)
        }
    }
    const percentageFund = formatWithoutRound(investment.percentageInWallet, 2);

    let contributionSection, contributionLinkSection;
    if(!isAlternativeFund && immFeatureFlags.get('wealth_funds_periodic_contributions')) {
        contributionLinkSection = (
            <p
                className="contribution__link"
                onClick={() => history.push('/myprofile/broker/contributionManagment')}
            >
                <FormattedText value="fundsCard-contributionPeriodicityLink"/>:
            </p>
        );
        if (brokerMyInvestments &&
            brokerMyInvestments.fundsContributionsList &&
            brokerMyInvestments.fundsContributionsList.list &&
            brokerMyInvestments.fundsContributionsList.list.recurringTransfers) {
            const fundContribution = brokerMyInvestments.fundsContributionsList.list.recurringTransfers
                .find(fund => fund.contractCode === investment.contractNumber);
            if (fundContribution) {
                const periodicity = fundContribution.periodicity;
                let periodicityText;
                if (periodicity) {
                    periodicityText = `fundsCard-contributionPeriodicity_${periodicity.toLowerCase()}`;
                } else {
                    periodicityText = 'fundsCard-contributionPeriodicity_monthly';
                }

                const amount = fundContribution.amount;
                const currencyCode = fundContribution.currencyCode;
                const amountObject = {
                    amount,
                    currency: formatCurrency(currencyCode)
                }
                contributionSection = (
                    <section className="purse__contribution">
                        <div className="contribution__container">
                            <p className="contribution__title">
                                <FormattedText value={periodicityText}/>:
                            </p>
                            <p className="contribution__amount">
                                <OneLineSymbolAmount
                                    amountObject={amountObject}
                                    amountObjectFormatted={formatAmountObject(amountObject, true)}
                                />
                            </p>
                        </div>
                    </section>
                );
            }
        }
    }

    return (
        <div className="user-fund-box__user-invested-box">
            <section className="purse__summary">
                <p className="summary--total">
                    <FormattedText
                        value="fundsCard-sharesHeld"
                        injectedStrings={[formatAmount(investment.shares)]}
                    />
                </p>
                <p className="summary--percent">
                    <span className="percent--title">
                        <FormattedText
                            value="fundsCard-percentageInWallet"
                            injectedStrings={[percentageFund]}
                        />
                    </span>
                    {investment.percentageInWallet > 0 &&
                        <PercentageBar percentage={formatAmount(investment.percentageInWallet)} />
                    }
                </p>
                <p className="summary--amount">
                    <span className="summary--amount">
                        <span className="summary_pamount">{formatAmount(investment.participaciones.amount)}&nbsp;</span>
                        <span>{getPlainAmountObject(investment.participaciones.currency)}</span>
                    </span>
                    {
                        investment.quoteCurrency !== 'EUR' &&
                        <OneLineSymbolAmount
                            amountObject={getPlainAmountObject(investment.quote)}
                            amountObjectFormatted={formatAmountObject(getPlainAmountObject(investment.quote), true)} />
                    }
                </p>
            </section>
            <section className="purse__rentability">
                <p className="rentability--title">
                    {formatText('fundsCard-profitability')}:
                </p>
                {buildProfitability(investment.earningsEur, investment.profitablePercentageEuros)}
            </section>
            <section className="purse__aditional">
                <p className="aditional--title">
                    {formatText('fundsCard-averagePrice')}:
                </p>
                <p className="aditional__price">
                    <span className="price--bold">
                        <OneLineSymbolAmount
                            amountObject={getPlainAmountObject(investment.averagePriceEur)}
                            amountObjectFormatted={formatAmountObject(getPlainAmountObject(investment.averagePriceEur), true)} />
                    </span>
                    {
                        investment.averagePriceCurrency !== 'EUR' &&
                        <span>{investment.averagePrice}&nbsp;{investment.averagePriceCurrency}</span>
                    }
                </p>
            </section>
            <section className="purse__capital">
                <p className="capital--title">
                    {formatText('fundsCard-investedCapital')}:
                </p>
                <p className="capital__price">
                    &nbsp;
                    <span className="price--bold">
                        <OneLineSymbolAmount
                            amountObject={getPlainAmountObject(investment.investmentEur)}
                            amountObjectFormatted={formatAmountObject(getPlainAmountObject(investment.investmentEur), true)} />
                    </span>
                    {
                        investment.investmentCurrency !== 'EUR' &&
                        <span>{investment.investment}&nbsp;{investment.investmentCurrency}</span>
                    }
                </p>
            </section>
            {contributionSection}
            <section className="purse__actions">
                {((fund.custom && fund.custom.customCategoryId3) || (isAlternativeFund && fund.marketable)) &&
                    <OKButton
                        modifier="primary"
                        onClick={() => buyButtonFund()}
                    >
                        {formatText('fundsCard-buyButton')}
                    </OKButton>
                }
                {!!onlyOneFundWithSameIsin && investment.shares > 0 &&
                    <OKButton
                        inverse={true}
                        modifier="ghost"
                        onClick={() => history.push(`/myprofile/broker/reimburseInvestment/${fund.customInstitutionSecurityId}/${onlyOneFundWithSameIsin}`)}
                    >
                        {formatText('fundsCard-sellButton')}
                    </OKButton>
                }
            </section>
            {contributionLinkSection}
        </div>
    )
};


UserInvestedBox.propTypes = {
    fund: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    investment: PropTypes.object.isRequired,
    immFeatureFlags: PropTypes.object.isRequired,
    brokerMyInvestments: PropTypes.object.isRequired,
    onlyOneFundWithSameIsin: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired,
    isAlternativeFund: PropTypes.bool,
};


module.exports = withRouter(UserInvestedBox);
